const RefValuesCategory = {
  PropertyOwnerType: 'PropertyOwnerType',
  CorrectionRequest: 'CorrectionRequest',
  CheckOutRequest: 'CheckOutRequest',
  EvidenceAuditResult: 'EvidenceAuditResult',
};

export default RefValuesCategory;
